<template>
	<!--	:name="vpEtikett"-->
	<!-- '#default' nedan = 'v-slot:default' = nya sättet att sätta 'slot-scope' och kallas 'slot props' (slotProps): -->
	<validation-provider ref="validationProvider"
		tag="div"
		mode="eagerMedBlurOchDebounce"
		:rules="vpValidationRules"
		#default="{ valid, errors, failedRules, flags }"
		class="_eui-form_losenstyrka_validation-provider"
	>
		<div
			:id="uniktId"
			class="_eui-form_losenstyrka"
			:class="{
				'-readonly':vpReadOnly,
				'-osynlig':skaVaraOsynlig,
				'-invalid':flags.validated && !valid,
			}"
			:title="vpTooltip"
		>
			<div v-if="vpEtikettbreddMedEnhet !== '0'"
				class="_eui-form_losenstyrka_etikett"
				:style="{ 'max-width':vpEtikettbreddMedEnhet }"
			></div>

			<div
				class="_eui-form_losenstyrka_rutyta"
				:style="{ 'max-width':vpRutbreddMedEnhet }"
			>
			<p v-if="vpEtikettOvanfor"
				class="_eui-form_losenstyrka_etikett-ovanfor"
			>
				<eui-modifierad-svg
					vp-ikon="hjalpknapp"
					style="
						stroke-width: 1.4;
						width: 1.2em;
						height: 1.2em;
						vertical-align: -.17em;
						margin-right: 0.3em;
						transform: translateX(-1px);
					"
				></eui-modifierad-svg>
				<span v-html="vpEtikettOvanfor"></span>
			</p>

				<!--
					– VeeValidate: The fields being validated *must have a v-model* so the component can correctly identify the element/component being validated.
					v-model.trim="innerValue"
				-->
				<input ref="inputelementet"
					v-model="losenStyrkaCustomData.Styrka"
					style="display:none !important;"
				>

				<div
					:disabled="skaVaraInaktiverad"
					class="_eui-form_losenstyrka_stapel"
					:style="{ 'max-width':vpStapelbreddMedEnhet }"
				>
					<div v-for="(steg, stegIndex) in stapelsteg" :key="stegIndex"
						:steg-index="stegIndex"
						class="_eui-form_losenstyrka_stapelsteg"
						:class="{
							[stapelstegFarg]:steg,
						}"
						:style="{
							width: stegBredd + '%',
						}"
					></div>
				</div>


				<!-- ##### Texter under stapeln: -->

				<div v-show="!!losenStyrkaCustomData.StyrkaHtml"
					class="_eui-form_losenstyrka_beskrivning"
					:disabled="skaVaraInaktiverad"
					v-html="losenStyrkaCustomData.StyrkaHtml"
				></div>

				<div v-show="!!losenStyrkaCustomData.VarningHtml"
					class="_eui-form_losenstyrka_varning -rod-text"
					:disabled="skaVaraInaktiverad"
					v-html="losenStyrkaCustomData.VarningHtml"
				></div>

				<div v-show="!!losenStyrkaCustomData.ForslagHtml"
					class="_eui-form_losenstyrka_forslag"
					:disabled="skaVaraInaktiverad"
					v-html="losenStyrkaCustomData.ForslagHtml"
				></div>


<!--
<span style="
	 width: 18%;
	 height: 0.4em;
	 background-color: #5cb85c;
	 display: inline-block;
	 margin-right: 2%;
	 float: left;
"></span>
-->
				<div class="_eui-form_losenstyrka_feltext">
					<div class="ellipsis" v-html="errors[0]">
						<!--{{ errors[0] }}-->
					</div>
				</div>

			</div>
		</div>
	</validation-provider>
</template>



<script>
	//#####################################################################################

	import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
	import { ValidationProvider } from 'vee-validate';

	import euiModifieradSvg from 'v-components/euiModifieradSvg';
	import objectToFormData from 'object-to-formdata';
	import { LosenStyrkaCustomData } from 'v-components/classes/euiFormLosenstyrkaClasses'

	//import throttla from 'lodash.throttle';
	import debounce from 'lodash.debounce';
	import { Base64 } from 'js-base64';

	import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
	VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	let uniktIdCounter = 0;


	export default {

		name: 'eui-form-losenstyrka',

		mixins: [euiLifecycleStatusesMixin],

		components: {
			euiModifieradSvg,
			'validation-provider': ValidationProvider,
		},

		props:
		{
			// must be included in props
			value: {
				type: null,
			},

			// Handle null in prop type:
			// Either use an empty string as the default/null value instead, or create a custom validator:
			//props: {
			//  object: {
			//    required.true,
			//    validator: prop => typeof prop === 'string' || prop === null
			//  }
			//}
			// Fick inte att funka:
			//type: String,
			//validator: prop => (prop === undefined || prop === null || typeof prop === 'string'),
			//required: true,
			//default: '',	// Blir detta om undefined/null
			vpLosen: {
				type: null,	//String,
				required: true,		//default: undefined,
			},

			vpUserInputs: {
				type: String,
				default: '',
			},

			vpEtikettOvanfor: {
				type: String,
				default: 'Så här säkert är ditt lösen:',
			},

			vpEtikettbreddMedEnhet: {		// '0' => ingen etikettkolumns renderas.
				type: String,
				default: '7rem',
			},
			vpRutbreddMedEnhet: {
				type: String,
				default: '22rem',
			},
			vpStapelbreddMedEnhet: {
				type: String,
				default: '100%',
			},

			vpValidationRules: {
				type: [Object, String],
				default: '',
			},

			vpTooltip: {
				type: String,			// Får innehålla HTML.
				default: `
Här ser du hur säkert ditt lösen bedöms vara. Välj ett
<br>lösen som ger en hög grön stapel.
`
//<br>Här visas också del specifika varningar och
//<br>tips om hur du kan välja ditt lösen.
			},

			vpReadOnly: {
				type: Boolean,
				default: false,
			},
			vpInaktiverad: {
				type: Boolean,
				default: false,
			},
			vpOsynlig: {
				type: Boolean,
				default: false,
			},
		},

		data()
		{
			return {
				uniktId: 'eui-form-losenstyrka-unikt-' + (++uniktIdCounter),

				// Ersatta med class-objekt nedan:
				//innerValue: undefined,		// undefined och 0 hanteras olika!!
				//varning: undefined,
				//forslag: undefined,

				// Styrka: undefined och 0 hanteras olika!!
				// VarningHtml: undefined = ingen.
				// ForslagHtml: undefined = inga.
				losenStyrkaCustomData: new LosenStyrkaCustomData(),

				antalSteg: 30,			// Jämn multipel av 5!
				stegMellanrum: 0.5,	// I hela procent (1-100).
			};
		},

		computed: {
			stegPerVardesteg() {
				return this.antalSteg / 5;
			},

			stegBredd() {
				// i hela procent (1-100):
				return (100 / this.antalSteg) - this.stegMellanrum;
			},

			vardeMotsvararDettaAntalSteg() {
				return (this.losenStyrkaCustomData.Styrka === undefined ?		// undefined och 0 hanteras olika!!
					0 :
					(this.losenStyrkaCustomData.Styrka + 1) * this.stegPerVardesteg
				);
			},

			stapelsteg()
			{
				const stapelsteg = [];

				for (let i = 0; i <= (this.antalSteg - 1); i++)
				{
					stapelsteg.push(i <= (this.vardeMotsvararDettaAntalSteg - 1) ? true : false);
				}

				return stapelsteg;
			},

			stapelstegFarg()
			{
				switch (this.losenStyrkaCustomData.Styrka)
				{
					case 2: return '-varning';

					case 3:
					case 4: return '-lyckat';
				}

				return '-fara';
			},

			styrka()		// Enkom för att kunna göra en enklare watch på denna ;)
			{
				return this.losenStyrkaCustomData.Styrka;
			},

			skaVaraOsynlig()
			{
				return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
			skaVaraInaktiverad()
			{
				return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
		},

		watch: {
			vpLosen(nyttVarde, tidigareVarde)
			{
				this.kollaLosenMenBaraOmDetBehovs();
			},

			vpUserInputs(nyttVarde, tidigareVarde)
			{
				// Kolla lösenstyrkan även om/då "userInputs" ändras:
				this.kollaLosenMenBaraOmDetBehovs();
			},

			// Handles internal model changes.

			// Ersatt nedan:
			//innerValue(nyttVarde, tidigareVarde)
			//{
			//	// För valideringens skull:
			//	this.$emit('input', nyttVarde);	// Funka ej: .trim());
			//},
			styrka(nyttVarde, tidigareVarde)
			{
				// För valideringens skull:
				this.$emit('input', nyttVarde);	// Funka ej: .trim());
			},

			// Handles external model changes.
			value(nyttVarde, tidigareVarde)
			{
				// Inget ska göras. Sådan här ska ALLTID vara reaktivt EFTER att interna värdet (losenStyrkaCustomData.Styrka) ändrats. "value" finns dock med för validering!
				//this.losenStyrkaCustomData.Styrka = nyttVarde;	// Funka ej: .trim();
			},
		},

		methods: {
			kollaLosenMenBaraOmDetBehovs()
			{
				if (!this.vpLosen || this.vpLosen === '')
				{
					this.losenStyrkaCustomData = new LosenStyrkaCustomData();	// = alla propar "undefined".
				}
				else
				{
					this.kollaLosen(this, this.vpLosen, this.vpUserInputs);
				}
			},

			kollaLosen: debounce((that, losen, userInputs) => {
					// Debounce (https://lodash.com/docs#debounce):
					//Arguments
					//func (Function): The function to debounce.
					//[wait=0] (number): The number of milliseconds to delay.
					//[options={}] (Object): The options object.
					//[options.leading=false] (boolean): Specify invoking on the leading edge of the timeout.
					//[options.maxWait] (number): The maximum time func is allowed to be delayed before it's invoked.
					//[options.trailing=true] (boolean): Specify invoking on the trailing edge of the timeout.

					that.$root.AjaxpostaOchHanteraResultat('/validate/losen-styrka', {
						formData: objectToFormData({
								losenBase64: Base64.encode(losen),
								userInputsBase64: Base64.encode(userInputs),
							}),

						withoutSpinner: true,
						//doljSpinnerOnSuccess: false,

						onFailureFunction: (resultat) => {
							// Servern returnerade ett fel:
							// Hantera silent:
							that.losenStyrkaCustomData = new LosenStyrkaCustomData();	// = alla propar "undefined".
						},

						onSuccessFunction: (resultat) => {
							// Sätt nya data att visa genom reaktivitet:
							that.losenStyrkaCustomData = LosenStyrkaCustomData.castFrom(resultat.CustomData);
						},

						onCatchedErrorFunction: (error) => {
							// Ett axios-fel har uppstått:

							// Todo: Silent eller inte? Det är frågan!

							//// Visa det:
							//this.$root.visaAxiosFelmeddelande(error);

							// Hantera silent:
							that.losenStyrkaCustomData = new LosenStyrkaCustomData();	// = alla propar "undefined".
						},
					});
				},

				500,	// Så lång debouncetid i ms.
				{ trailing: true, leading: false,	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
					maxWait: 1000
				}
			),
		},

		//== Lifecycle hooks  ================================================================================================================

		created()
		{
			if (this.value)
			{
				// Inget ska göras. Just "value" kan/får inte skickas med initialt. Måste alltid vara undefined. "value" finns dock med för validering!
				//this.losenStyrkaCustomData.Styrka = this.value;
			}
		},

		//mounted()
		//{
		//	this.$nextTick(function() {
		//	});
		//},
	}
</script>
